import { useQuery } from "@apollo/react-hooks";

import getDDIDocumentUrl from "../graph-ql/getDDIDocumentUrl.graphql";

const useQueryGetDDIDocumentUrl = () => useQuery(getDDIDocumentUrl);

export default useQueryGetDDIDocumentUrl;
